/* eslint-disable react/no-unknown-property */
import React from 'react'
import {useEffect, useState} from 'react'
import {printSO} from '../../../api/modules/so'

export default function So() {
  const [dataSO, setDataSO] = useState({})

  const getData = async () => {
    await printSO(sessionStorage.getItem('id'))
      .then((res) => {
        setDataSO(res.data.data)
      })
      .catch(function (error) {})
  }

  const printing = () => {
    const getData = setTimeout(async () => {
      window.print()
    }, 2000)

    return () => clearTimeout(getData)
  }

  useEffect(() => {
    getData()

    printing()
  }, [])

  const td5 = {
    width: '5%',
    border: '0.5px solid black',
    borderCollapse: 'collapse',
    letterSpacing: '0.5px',
  }
  const td15 = {
    width: '15%',
    border: '0.5px solid black',
    borderCollapse: 'collapse',
    letterSpacing: '0.5px',
  }
  const td20 = {
    width: '20%',
    border: '0.5px solid black',
    borderCollapse: 'collapse',
    letterSpacing: '0.5px',
  }
  const td100 = {
    width: '100%',
    border: '0.5px solid black',
    borderCollapse: 'collapse',
    letterSpacing: '0.5px',
    marginTop: '8px',
  }
  const tdnull = {
    borderLeft: '0.5px solid white',
    borderBottom: '0.5px solid white',
  }
  const tdnullR = {
    borderRight: '0.5px solid white',
    borderLeft: '0.5px solid white',
    borderBottom: '0.5px solid white',
  }
  const p = {
    fontSize: '12px',
    fontweight: '400',
    margin: '0',
    padding: '0',
    letterSpacing: '0.5px',
  }
  const b = {
    fontSize: '14px',
    margin: 0,
    letterSpacing: '0.5px',
  }
  const bU = {
    fontSize: '14px',
    margin: 0,
    letterSpacing: '0.5px',
    textDecoration: 'underline',
  }
  const text = {
    textAlign: 'center',
    fontSize: '12px',
    margin: 0,
    letterSpacing: '0.5px',
  }
  const mr5 = {
    marginRight: '8px',
  }
  return (
    <div>
      <center>
        <h2
          style={{
            textDecoration: 'underline',
            marginTop: '32px',
            marginBottom: '0px',
            padding: '0px',
          }}
        >
          SALES ORDER
        </h2>
        <p style={p}>{dataSO.so_number}</p>
        <p style={p}>{dataSO.so_date}</p>
      </center>
      <div style={{marginTop: '32px'}}>
        <p style={p}>Kepada Yth.</p>
        <b>
          {dataSO.title} {dataSO.customer_name}
        </b>
        <p style={p}>{dataSO.address}</p>
        <p style={p}>{dataSO.city}</p>
        <p style={p}>{dataSO.region}</p>
      </div>
      <br />
      <br />
      <p style={p}>Dengan hormat,</p>
      <br />
      <p style={p}>Bersama ini kami sampaikan rincian pembelian sebagai berikut :</p>
      <table cellpadding='0' cellspacing='0' style={td100}>
        <tr>
          <td style={td5}>
            <center>
              <b style={b}>No</b>
            </center>
          </td>
          <td style={td20}>
            <center>
              <b style={text}>PRODUK</b>
            </center>
          </td>
          <td style={td15}>
            <center>
              <b style={text}>SPESIFIKASI</b>
            </center>
          </td>
          <td style={td15}>
            <center>
              <b style={text}>KUANTITAS</b>
            </center>
          </td>
          <td style={td15}>
            <center>
              <b style={text}>INCOTERM</b>
            </center>
          </td>
          <td style={td15}>
            <center>
              <b style={text}>PLANT</b>
            </center>
          </td>
        </tr>
        {dataSO?.so_items?.data?.map((data, index) => (
          <tr key={index}>
            <td style={td5}>
              <center>
                <p style={p}>{index + 1}</p>
              </center>
            </td>
            <td style={td20}>
              <center>
                <p style={p}>{data.order_sub_detail?.product_name}</p>
              </center>
            </td>
            <td style={td15}>
              <center>
                <p style={p}>{data.order_sub_detail?.product_spec}</p>
              </center>
            </td>
            <td style={td15}>
              <center>
                <p style={p}>{data.quantity?.toLocaleString()} Ton</p>
              </center>
            </td>
            <td style={td15}>
              {data.order_sub_detail?.incoterm2 == null ||
              data.order_sub_detail?.incoterm2 == '' ? (
                <center>
                  <p style={p}>{data.order_sub_detail?.incoterm1?.code}</p>
                </center>
              ) : (
                <center>
                  <p style={p}>
                    {data.order_sub_detail?.incoterm1?.code}-
                    {data.order_sub_detail?.incoterm2?.code}
                  </p>
                </center>
              )}
            </td>
            <td style={td15}>
              <center>
                <p style={p}>
                  {data.order_sub_detail?.plant}-{data.order_sub_detail?.plant_desc}
                </p>
              </center>
            </td>
          </tr>
        ))}
        <tr>
          <td style={tdnull}></td>
          <td colspan='2' style={td5}>
            <center>
              <b>SUB TOTAL</b>
            </center>
          </td>
          <td style={td5}>
            <center>
              <p style={p}>{dataSO?.so_items?.total_quantum?.toLocaleString()} Ton</p>
            </center>
          </td>
          <td style={tdnull}></td>
          <td style={tdnullR}></td>
        </tr>
      </table>
      <br />
      <br />
      <table style={{width: '40%'}}>
        <tr>
          <td>
            <p style={p}>Alat Angkut</p>
          </td>
          <td>
            <p style={p}>
              <span style={mr5}> : </span> {dataSO.moda_ankut_name}
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <p style={p}>Sektor</p>
          </td>
          <td>
            <p style={p}>
              <span style={mr5}> : </span> {dataSO.sektor}
            </p>
          </td>
        </tr>
        <tr>
          {dataSO.type == 'Korporasi' ? (
            <>
              <td>
                <p style={p}>No. Kontrak</p>
              </td>
              <td>
                <p style={p}>
                  <span style={mr5}> : </span> {dataSO.contract_number}
                </p>
              </td>
            </>
          ) : (
            <></>
          )}
        </tr>
      </table>
      <br />
      <p style={p}>
        Produk tersebut harap diambil di plant yang telah ditentukan paling lambat{' '}
        {dataSO.valid_date}
      </p>
      <br />
      <p style={p}>Demikian disampaikan, atas perhatiannya diucapkan terima kasih</p>
      <br />
      <b style={b}>{dataSO.sales_organization}</b>
      <br />
      <img src='ttd.png' alt='' style={{maxWidth: '150px'}} />
      <br />
      <b style={bU}>{dataSO.assigner_name}</b>
      <br />
      <b style={b}>{dataSO.assigner_position}</b>
    </div>
  )
}
